/**
 * PushNudge - one-time dismissible card asking the signed-in user to turn on
 * notifications. The enable button runs inside the tap (iOS gesture rule).
 * Hidden when unsupported, not installed (iOS browser tab), already enabled,
 * permission already decided, or previously dismissed.
 */
import { Bell, X } from 'lucide-react';
import { usePushStore } from '../store/pushStore';

export default function PushNudge() {
  const { supported, needsInstall, enabled, busy, nudgeDismissed, enablePush, dismissNudge } =
    usePushStore();

  const show =
    supported &&
    !needsInstall &&
    !enabled &&
    !nudgeDismissed &&
    Notification.permission === 'default';

  if (!show) return null;

  return (
    <div className="fixed bottom-24 left-0 right-0 z-40 flex justify-center px-4 pb-safe">
      <div className="flex w-full max-w-sm items-center gap-3 rounded-2xl border border-border bg-surface p-3 shadow-lg animate-slide-up">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary">
          <Bell size={18} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-text">Don't miss a moment</p>
          <p className="text-xs text-text-muted">Get notified when friends send you something</p>
        </div>
        <button
          onClick={() => {
            void enablePush().then(() => dismissNudge());
          }}
          disabled={busy}
          className="shrink-0 rounded-full bg-primary px-3 py-1.5 text-xs font-semibold text-white disabled:opacity-50"
        >
          Turn on
        </button>
        <button
          onClick={dismissNudge}
          aria-label="Dismiss"
          className="shrink-0 text-text-muted"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
